import React from "react";
export var KnockFeedContainer = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-feed-provider"
  }, children);
};
//# sourceMappingURL=KnockFeedContainer.js.map